/**
 * Shared loading / error / empty state when roadmap config is fetched from the Worker (D1).
 */
export function CompanyConfigPlaceholder({
  companyId,
  loading,
  error,
  config,
}: {
  companyId?: string;
  loading: boolean;
  error?: string;
  config: unknown;
}) {
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center font-manrope">
        <p className="text-muted-foreground animate-pulse">Loading…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-screen flex items-center justify-center font-manrope px-6">
        <div className="text-center max-w-lg">
          <h1 className="text-2xl font-bold mb-2">Could not load config</h1>
          <p className="text-muted-foreground mb-4">{error}</p>
          <p className="text-sm text-muted-foreground leading-relaxed">
            The roadmap reads <code className="text-xs bg-muted px-1 py-0.5 rounded">RoadmapCompanyConfig</code> from{' '}
            <code className="text-xs bg-muted px-1 py-0.5 rounded">GET /api/roadmap/&lt;slug&gt;</code> on the Worker
            (D1). For local dev, set <code className="text-xs bg-muted px-1 py-0.5 rounded">VITE_API_URL</code> in{' '}
            <code className="text-xs bg-muted px-1 py-0.5 rounded">apps/roadmap/.env.development</code> to your Worker
            base URL (no trailing slash), then restart Vite.
          </p>
        </div>
      </div>
    );
  }

  if (!config) {
    return (
      <div className="h-screen flex items-center justify-center font-manrope">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-2">Company Not Found</h1>
          <p className="text-muted-foreground">
            No configuration found for &ldquo;{companyId}&rdquo;
          </p>
          <p className="text-sm text-muted-foreground mt-3 max-w-md mx-auto">
            If this slug should exist, confirm a row in D1{' '}
            <code className="text-xs bg-muted px-1 py-0.5 rounded">roadmap_companies</code> and programs in{' '}
            <code className="text-xs bg-muted px-1 py-0.5 rounded">roadmap_programs</code> for this slug.
          </p>
        </div>
      </div>
    );
  }

  return null;
}
